<template>
  <div class="basket-wrapper">
    <div class="basket-handler">
      <div id="basket-btn" class="basket-btn">
        <i class="el-icon-takeaway-box"></i>
        <p class="text">试题篮</p>
      </div>
      <div class="basket-num">
        <span class="text">{{ userBasketTotalCount }}</span>
      </div>
    </div>
    <div class="basket-container">
      <div class="basket-container-box">
        <div class="basket-header">
          <span class="space"></span>
          <div class="l">
            <span>已加入试题（共</span
            ><span class="t"> {{ userBasketTotalCount }} </span
            ><span>题）</span>
          </div>
        </div>
        <div class="basket-body">
          <div class="basket-content" style="" v-if="userBasketList.length > 0">
            <div class="ul-box">
              <ul>
                <li
                  class="list-item"
                  v-for="(value, index) in userBasketList"
                  :key="index"
                >
                  <span class="item-type">{{ value.types_name }}</span
                  ><span class="item-num font-12"
                    ><em class="text">{{ value.count }}</em
                    >题 </span
                  ><span
                    class="item-del"
                    @click="onDeleteQuestion(value.types_code)"
                    ><i class="el-icon-delete"></i
                  ></span>
                </li>
              </ul>
            </div>
            <div class="basket-empty">
              <span class="empty-box" @click="onCleanQuestion"
                ><i class=""></i><span class="text">清空试题</span></span
              >
            </div>
            <div class="flex-row">
              <el-button type="primary" round size="mini" @click="onLooksBasket"
                >试卷预览</el-button
              >
            </div>
          </div>
          <div class="basket-noresult" v-else>
            <div class="icon-box">
              <i class="noresult-icon"></i>
            </div>
            <p class="noresult-text font-16 color-3">
              试题篮空空的~
            </p>
            <p class="noresult-text1 font-12 color-9">
              您还没有添加试题，赶快去添加吧！
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "basket",
  data() {
    return {
      userBasketTotalCount: 0,
      userBasketList: [],
    };
  },
  props: {
    stageCode: Number,
    subjectCode: Number,
    types: Number,
  },
  created() {
    this.getUserQuestion();
  },
  methods: {
    getUserQuestion() {
      let url = "/wenjiaoopne/kc/basket/get";
      if (this.types === 1) {
        url = "/wenjiaoopne/kc/basket/work/getBasket";
      }
      this.postRequest(url, {
        stage_id: this.stageCode,
        subject_id: this.subjectCode,
      })
        .then((result) => {
          this.userBasketList = result.data.list;
          this.userBasketTotalCount = result.data.total_count;
        })
        .catch(() => {});
    },
    onLooksBasket() {
      if (this.types === 1) {
        this.$router.push("/work/browse");
      } else {
        this.$router.push("/ti/browse");
      }
    },
    onDeleteQuestion(code) {
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          let url = "/wenjiaoopne/kc/basket/delete";
          if (this.types === 1) {
            url = "/wenjiaoopne/kc/basket/work/delete";
          }
          this.postRequest(url, {
            type_id: code,
            stage_id: this.stageCode,
            subject_id: this.subjectCode,
          })
            .then((result) => {
              this.$emit("deleteCallBack", result);
              this.getUserQuestion();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onCleanQuestion() {
      this.$confirm("确定要清空吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          let url = "/wenjiaoopne/kc/basket/clean";
          if (this.types === 1) {
            url = "/wenjiaoopne/kc/basket/work/clean";
          }
          this.postRequest(url, {
            stage_id: this.stageCode,
            subject_id: this.subjectCode,
          })
            .then((result) => {
              this.$emit("deleteCallBack", result);
              this.getUserQuestion();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.basket-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1005;
  width: 0;
  -webkit-box-shadow: -3px 3px 6px 0 rgba(42, 77, 138, 0.2);
  box-shadow: -3px 3px 6px 0 rgba(42, 77, 138, 0.2);
  background: #41b9f1;
  font-size: 14px;
}
.basket-wrapper:hover .basket-container {
  position: absolute;
  width: 300px;
  left: -326px;
  top: calc(50% - 45px);
}
.basket-wrapper:hover .basket-container .basket-header {
  height: 50px;
  background: #f6f6f6;
  border-radius: 6px 6px 0 0;
  line-height: 50px;
  color: #333;
  font-size: 16px;
}
.basket-wrapper .basket-container {
  left: 0;
}
.basket-container-box {
  width: 260px;
  background: #fff;
  -webkit-box-shadow: 0 4px 32px 0 rgba(42, 77, 138, 0.3);
  box-shadow: 0 4px 32px 0 rgba(42, 77, 138, 0.3);
  border-radius: 6px;
  min-height: 286px;
}
.basket-header {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.basket-header .space {
  width: 20px;
  height: 50px;
}
.basket-header .l {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.basket-header .t {
  color: #ff6e5d;
  font-weight: 700;
}
.basket-header .r {
  width: 40px;
  text-align: center;
  cursor: pointer;
  color: #999;
}
.basket-header .r:hover {
  color: #666;
}
.basket-handler {
  position: absolute;
  top: 50%;
  left: -40px;
  width: 40px;
  height: 90px;
  margin-top: -45px;
  background: #41b9f1;
  -webkit-box-shadow: -3px 3px 6px 0 rgba(42, 77, 138, 0.2);
  box-shadow: -3px 3px 6px 0 rgba(42, 77, 138, 0.2);
  border-radius: 4px 0 0 4px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
.basket-handler:hover {
  background: #41b9f1;
}
.basket-handler .basket-btn {
  padding: 10px 13px;
  cursor: pointer;
  color: #fff;
}
.basket-handler .basket-btn .iconshitilan {
  font-size: 16px;
}
.basket-handler .basket-btn .text {
  margin-top: 5px;
  line-height: 16px;
}
.basket-handler .basket-num {
  position: absolute;
  top: -5px;
  left: -12px;
  background: #ff6e5d;
  border-radius: 10px;
  padding: 1px 7px;
}
.basket-handler .basket-num .text {
  color: #fff;
  font-size: 12px;
}
.basket-body {
  padding: 10px 10px;
  background: #fff;
}
.basket-body .list-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.basket-body .list-item .item-type {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 135px;
}
.basket-body .list-item .item-num {
  width: 40px;
}
.basket-body .list-item .item-num .text {
  margin-right: 2px;
  font-size: 14px;
  color: #ff6e5d;
}
.basket-body .list-item .item-del {
  width: 14px;
  height: 14px;
  line-height: 14px;
  border-radius: 50%;
  background: #eceff3;
  text-align: center;
  cursor: pointer;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  font-size: 10px;
}
.basket-body .list-item .item-del .iconclose {
  font-size: 10px;
}
.basket-body .list-item .item-del:hover .iconclose {
  color: #fff;
  font-size: 10px;
}
.basket-body .list-item:hover {
  background: #f6f6f6;
  border-radius: 4px;
}
.basket-body .basket-empty {
  margin: 15px 0 20px 0;
  text-align: right;
}
.basket-body .basket-empty .empty-box {
  cursor: pointer;
  color: #bababa;
  font-size: 12px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
.basket-body .basket-empty .empty-box .iconnonebg-delete {
  margin-right: 5px;
  font-size: 14px;
}
.basket-body .basket-empty .empty-box:hover {
  color: #41b9f1;
}
.basket-body .basket-preview {
  border-radius: 16px;
  padding: 9px 45px;
  margin: 0 50px;
  background-color: #41b9f1;
}
.basket-body .basket-noresult {
  text-align: center;
}
.basket-body .basket-noresult .icon-box {
  display: inline-block;
  width: 107px;
  height: 122px;
  margin-bottom: 26px;
}
.basket-body .basket-noresult .icon-box .noresult-icon {
  display: inline-block;
  width: 72px;
  height: 88px;
  padding: 0 12px;
  margin-top: 30px;
  background: url(../../assets/images/list_null.png) no-repeat;
  background-size: 72px 88px;
  background-position: 50%;
}
.basket-body .basket-noresult .noresult-text {
  margin-bottom: 14px;
}
.basket-content .ul-box {
  min-height: 120px;
  max-height: 300px;
  overflow-y: auto;
}
.basket-content > ul {
}
.backtop-container {
  background: #619cf5;
  -webkit-box-shadow: -3px 3px 6px 0 rgba(42, 77, 138, 0.2);
  box-shadow: -3px 3px 6px 0 rgba(42, 77, 138, 0.2);
  border-radius: 4px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
.backtop-container .icon-box {
  display: inline-block;
  width: 20px;
  height: 20px;
}
</style>
